import { render, staticRenderFns } from "./contractual-risk.vue?vue&type=template&id=60246cdc&scoped=true"
import script from "./contractual-risk.vue?vue&type=script&lang=js"
export * from "./contractual-risk.vue?vue&type=script&lang=js"
import style0 from "./contractual-risk.vue?vue&type=style&index=0&id=60246cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60246cdc",
  null
  
)

export default component.exports